/**
 * Boundary
 * 
 * @Author: Focci
 * @Date: 2023-08-20 10:22:16
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-20 10:22:16
 */

import PropTypes from 'prop-types'
import BoundaryText from '@comp/mapbox/BoundaryText'
import useFetch from '@hook/useFetch'
import { useMap } from 'react-map-gl'
import { Boundary, fitBounds } from '@comp/mapbox'
import { isArray } from 'lodash-es'
import { objectCoordToArray } from '@lib/utils'
import { useEffect } from 'react'

export default function LocationBoundary({
  propertyId,
  needFitBounds = true,
  fitPadding = 150,
  boundaryLineColor,
}) {
  const { current } = useMap()
  const url = propertyId ? `property-boundaries/${propertyId}` : null
  const { data } = useFetch(url)
  const { boundaries, boundary_distances: distances } = data || {}

  useEffect(() => {
    needFitBounds && boundaries && fitBounds(current, boundaries, fitPadding)
  }, [current, boundaries, needFitBounds, fitPadding])

  if(!(isArray(distances) && isArray(boundaries))) {
    return null
  }

  const boundaryData = objectCoordToArray(boundaries)
  
  return (
    <>
      {data.boundaries.length > 0 && (
        <Boundary data={boundaryData} color={boundaryLineColor} />
      )}
      {data.boundary_distances.length > 0 && (
        <BoundaryText 
          data={data.boundary_distances}
        />
      )}
    </>
  )
}

LocationBoundary.propTypes = {
  propertyId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
}
